'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

var _STR_BUTTON = require('./_constants/STR_BUTTON');

var _STR_BUTTON2 = _interopRequireDefault(_STR_BUTTON);

var _STR_BUTTON_LC = require('./_constants/STR_BUTTON_LC');

var _STR_BUTTON_LC2 = _interopRequireDefault(_STR_BUTTON_LC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (0, _alias2.default)(_STR_BUTTON_LC2.default, _STR_BUTTON2.default); /**
                                                                                   * Alias for the button tag.  The Button should be used when performing a user
                                                                                   * action such as a form submission or popping a dialog.
                                                                                   *
                                                                                   * @module Button
                                                                                   * @func
                                                                                   * @since 1.0.0
                                                                                   * @param {Object} props
                                                                                   */

exports.default = Button;